//import { ReactComponentElement } from "react";
//import { ReactComponent as OrdersSvg } from "../assets/icons/orders.svg";

export function createMinMediaSelector(width: number): string {
    return `(min-width: ${width + 1}px)`;
}

export function createMaxMediaSelector(width: number): string {
    return `(max-width: ${width}px)`;
}

export function createBetweenMediaSelector(minWidth: number, maxWidth: number): string {
    return `(min-width: ${minWidth + 1}px) and (max-width: ${maxWidth}px)`;
}
